import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/company/ceomessage",
    name: "ceomessage",
    component: () => import("../views/company/ceomessageView.vue"),
  },
  {
    path: "/company/ability",
    name: "ability",
    component: () => import("../views/company/abilityView.vue"),
  },
  {
    path: "/company/history",
    name: "history",
    component: () => import("../views/company/historyView.vue"),
  },
  {
    path: "/company/patent",
    name: "patent",
    component: () => import("../views/company/patentView.vue"),
  },
  {
    path: "/solutions/coilDoctor",
    name: "coilDoctor",
    component: () => import("../views/solutions/coilDoctor.vue"),
  },
  {
    path: "/solutions/electroceuticals",
    name: "electroceuticals",
    component: () => import("../views/solutions/electroceuticalsView.vue"),
  },
  {
    path: "/solutions/sleeptech",
    name: "sleeptech",
    component: () => import("../views/solutions/sleeptechView.vue"),
  },
  {
    path: "/solutions/gfyjiggy",
    name: "gfyjiggy",
    component: () => import("../views/solutions/gfyjiggyView.vue"),
  },
  {
    path: "/solutions/rpm",
    name: "rpm",
    component: () => import("../views/solutions/rpmView.vue"),
  },
  {
    path: "/solutions/electroceuticals2",
    name: "electroceuticals2",
    component: () => import("../views/solutions/electroceuticals2View.vue"),
  },
  {
    path: "/solutions/pemf",
    name: "pemf",
    component: () => import("../views/solutions/pemfView.vue"),
  },

  {
    path: "/technology/kiosk",
    name: "kiosk",
    component: () => import("../views/technology/kioskView.vue"),
  },
  {
    path: "/technology/fallDetector",
    name: "fallDetector",
    component: () => import("../views/technology/fallDetectorView.vue"),
  },
  {
    path: "/technology/edgeBox",
    name: "edgeBox",
    component: () => import("../views/technology/edgeBoxView.vue"),
  },
  {
    path: "/technology/mEdgeBox",
    name: "mEdgeBox",
    component: () => import("../views/technology/mEdgeBoxView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/contact/contactView.vue"),
  },
  {
    path: "/recruit",
    name: "recruit",
    component: () => import("../views/recruit/recruitView.vue"),
  },
  {
    path: "/news",
    name: "news",
    component: () => import("../views/news/newsView.vue"),
  },
  // KO
  {
    path: "/terms-of-service",
    component: () => import("../views/terms/TermsOfServiceView.vue"),
  },
  {
    path: "/location-terms",
    component: () => import("../views/terms/LocationTermsView.vue"),
  },
  {
    path: "/privacy-policy",
    component: () => import("../views/terms/PrivacyPolicyView.vue"),
  },
  {
    path: "/delete-account",
    component: () => import("../views/terms/DeleteAccount.vue"),
  },

  // EN
  {
    path: "/en/terms-of-service",
    component: () => import("../views/terms/en/TermsOfServiceViewEn.vue"),
  },
  {
    path: "/en/location-terms",
    component: () => import("../views/terms/en/LocationTermsViewEn.vue"),
  },
  {
    path: "/en/privacy-policy",
    component: () => import("../views/terms/en/PrivacyPolicyViewEn.vue"),
  },
  {
    path: "/en/delete-account",
    component: () => import("../views/terms/en/DeleteAccountEn.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 이전에 저장된 위치로 스크롤 (브라우저 뒤로가기)
    } else {
      return { top: 0 }; // 페이지 전환 시 스크롤 맨 위로
    }
  },
});

export default router;
